export default __webpack_public_path__ + "static/media/bethany.bdc9f3b7.png";